export default {
  Entities: [],
  Links: [
    {
      Href: 'http://localhost/tlp/api/v2/search/categories',
      Rel: 'self',
    },
  ],
};
